module.exports = "<div>\n  <h1>¡Bienvenido(a)!</h1>\n  <p>Ingresa tus datos para continuar</p>\n</div>\n<login-form></login-form>\n"